// Shared error banner für Widgets mit Retry-Button
import { AlertTriangle, RefreshCw } from 'lucide-react';

export function ErrorBanner({ error, onRetry, compact = false }: {
  error: unknown;
  onRetry?: () => void;
  compact?: boolean;
}) {
  const msg = error instanceof Error ? error.message : String(error ?? 'Unbekannter Fehler');
  return (
    <div className={`${compact ? 'p-3 text-xs' : 'p-4 text-sm'} bg-red-50 border-l-4 border-red-500 text-red-800 flex items-start gap-2`}>
      <AlertTriangle className={`${compact ? 'w-4 h-4' : 'w-5 h-5'} flex-shrink-0 mt-0.5`} />
      <div className="flex-1 min-w-0">
        <div className="font-semibold">Fehler beim Laden</div>
        <div className="text-xs opacity-75 break-words">{msg}</div>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-1 text-xs font-medium bg-white border border-red-300 rounded px-2 py-1 hover:bg-red-100"
        >
          <RefreshCw className="w-3 h-3" /> Retry
        </button>
      )}
    </div>
  );
}
